<template>
  <div id="fullcontent">
    <LeftMenu
      :expanded="menu_expanded"
      @closeMenu="closeMenu"
      :key="this.$route.fullPath"
    ></LeftMenu>

    <div class="toogle-content">
      <div
        class="toggle-menu"
        :class="{ opened: menu_expanded }"
        @click="toggleMenu"
      ></div>
    </div>

    <div id="main-content" :class="{ expanded: menu_expanded }">
      <Topbar></Topbar>
      <div class="estimate info" v-if="banner_module">
        <p class="text" v-html="$t(banner_module)"></p>
      </div>
      <section id="container"><router-view /></section>
    </div>
  </div>
</template>

<script>
import LeftMenu from "@/components/layout/LeftMenu";
import Topbar from "@/components/layout/Topbar";
import i18n from "@/i18n";

export default {
  components: {
    // Header,
    LeftMenu,
    Topbar
  },
  data() {
    return {
      menu_expanded: false
    };
  },
  computed: {
    banner_module() {
      var banner_name = "volunteers.banner.";
      if (this.$route.params.event_id) {
      } else {
        banner_name += "main";
      }

      return i18n.t(banner_name) == banner_name ||
        i18n.t(banner_name) == "false"
        ? false
        : i18n.t(banner_name);
    }
  },
  methods: {
    closeOverlay() {
      this.$store.commit("setOverlayVisible", false);
    },

    toggleMenu() {
      var self = this;
      // this.menu_expanded ? this.$overlay.hide() : this.$overlay.show({ callClick: function(){
      //   self.$overlay.hide();
      //   self.menu_expanded = false;
      // } });
      this.menu_expanded = !this.menu_expanded;
    },

    closeMenu() {
      this.$overlay.hide();
      this.menu_expanded = false;
    }
  },
  created() {
    this.$store.commit("setMenuVisible", false);
  },
  watch: {
    // '$route' : 'closeOverlay',
    $route: "toggleMenu"
  }
};
</script>

<style lang="scss">
#fullcontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.toggle-menu {
  display: none;
}

#main-content {
  height: 100%;
  width: calc(100% - 300px);
  margin-left: 300px;
  float: left;
  overflow: hidden;
  display: block;
  position: relative;
  // overflow: auto;
  // padding: 25px;
  background-color: #fff;

  &.expanded {
    // width: calc( 100% - 300px );
    // margin-left: 300px;
  }

  #container {
    height: 100%;
    margin-top: 0px;
    padding: 25px 30px 80px 30px;
    padding-top: 0px;
  }

  .estimate {
    @include display-flex();
    @include align-items();
    @include flex-wrap(wrap);
    @include background(
      $color: $warning-color-light,
      $image: img("empty_estimated_warning.svg"),
      $position: left 25px center,
      $size: 40px
    );
    width: 100%;
    // min-height: 100px;
    height: auto;
    padding: 10px;
    padding-left: 80px;
    margin: 24px auto;
    border-radius: 3px;

    &.info {
      width: calc(100% - 300px);

      .text {
        margin-bottom: 0;
      }
    }
  }

  @include media(">phone", "<tablet") {
    width: 100%;
    margin-left: 0;
  }
}

@include media(">phone", "<tablet") {
  #main-content.expanded {
    width: 100%;
    margin-left: 0;
  }

  #main-content {
    #container {
      height: auto !important;
      padding: 25px 20px;
      padding-bottom: 50px;
      padding-top: 0;
    }
  }

  #content {
    padding-top: 0;
  }

  .toogle-content {
    height: 50px;
    background-color: white;
  }

  .toggle-menu {
    @include background($image: img("hmenu.svg"), $size: 26px);
    position: fixed;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    z-index: 30;
    display: block;
    transition-duration: 0.2s;
    cursor: pointer;

    &.opened {
      background-image: img("hmenu_light.svg");
      left: unset;
      right: 0;
    }
  }
}

@media print {
  #fullcontent {
    #main-content {
      width: 100% !important;
      margin: 0 !important;
    }
  }

  @page {
    size: auto;
    margin: 20px 0;
  }
}
</style>
